export interface DocumentationIds {
  documentationId: string;
  versionId: string;
}
export function createDocumentationFileSignedRequestUrl(
  ids: DocumentationIds
): string {
  return `/documentation/${ids.documentationId}/version/${ids.versionId}/download`;
}
